import React from 'react'
import PropTypes from 'prop-types'
import Step from '../../../components/Step'
import Select from 'react-select'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import * as validation from 'lib/validation'
import './SiteTools.scss'

const USER = 'User'
const USER_PASSWORD = 'UserPassword'

const DEVICES = 'Devices'

export default class AtHomeCreationView extends React.Component {
  static propTypes = {
    isFetchingUsers: PropTypes.bool,
    isFetchingDevices: PropTypes.bool,
    createUser: PropTypes.func,
    createdUser: PROPTYPES.user,
    updatedUser: PROPTYPES.user,
    users: PROPTYPES.users,
    devices: PROPTYPES.devices,
    associateDeviceWithUser: PropTypes.func,
    dissociateDeviceWithUser: PropTypes.func,
  }

  static defaultProps = {
    isFetchingUsers: false,
    isFetchingDevices: false,
    createUser: _.noop,
    createdUser: null,
    updatedUser: null,
    users: [],
    devices: [],
    associateDeviceWithUser: _.noop,
    dissociateDeviceWithUser: _.noop,
  }

  constructor (props) {
    super(props)
    this.state = {
      [`selected${USER}`]: null,
      [`selected${USER_PASSWORD}`]: null,
      [`selected${DEVICES}`]: null,
      [`input${USER}`]: '',
      [`input${USER_PASSWORD}`]: '',
      [`input${DEVICES}`]: '',
      devicesComplete: false,
    }
  }

  // check to see if requirements are met before enabling user to take action, true if prereqs met
  checkPrereqs = (resourceType) => {
    const self = this
    const {
      selectedUser,
      inputUser,
      inputUserPassword,
      selectedDevices,
    } = this.state
    const { createdUser } = this.props
    if (resourceType === USER) {
      if ((selectedUser || createdUser) || (inputUser && inputUserPassword)) {
        return true
      }
    }
    if (resourceType === DEVICES) {
      if (createdUser || selectedUser) {
        if (selectedDevices && selectedDevices.length > 0) {
          return true
        }
      }
    }
    return false
  }

  handleSelect = (resourceType, selected) => {
    if (selected == null) {
      selected = ''
    }
    this.setState({ [`selected${resourceType}`]: selected })
  }

  handleInput = (resourceType, input) => {
    this.setState({ [`input${resourceType}`]: input })
    return input
  }

  getDeviceIds = () => {
    const { selectedDevices } = this.state
    return _.map(selectedDevices, (device) => {
      return device.device_id
    })
  }

  getDeviceStrings = () => {
    const { selectedDevices } = this.state
    return _.map(selectedDevices, (device) => {
      return device.id // device_string is returned by api as id and device_string
    })
  }

  handleAssociateDevicesClick = (currentUserSubject) => {
    this.setState({ devicesComplete: true })
    const deviceStrings = this.getDeviceStrings()
    return Promise.all(_.map(deviceStrings, (deviceString) => {
    	return this.props.associateDeviceWithUser(deviceString, currentUserSubject.user_id)
    }))
  }

  handleDissociateDevicesClick = (currentUserSubject) => {
    this.setState({ devicesComplete: true })
    const deviceStrings = this.getDeviceStrings()
    return Promise.all(_.map(deviceStrings, (deviceString) => {
    	return this.props.dissociateDeviceWithUser(deviceString, currentUserSubject.user_id)
    }))
  }

  handleCreateUser = () => {
    const { inputUser, inputUserPassword } = this.state
    const { createUser } = this.props
    const userResult = validation.validateUser(inputUser)
    const passwordResult = validation.validatePassword(inputUserPassword)
    this.setState({
      [`alert${USER}`]: {
        show: !userResult.valid,
        errors: userResult.errors
      },
      [`alert${USER_PASSWORD}`]: {
        show: !passwordResult.valid,
        errors: passwordResult.errors
      }
    })
    if (userResult.valid && passwordResult.valid) {
      createUser(inputUser, inputUserPassword, 'PROVIDER')
    }
  }

  renderAlert = (resourceType) => {
    const alert = this.state[`alert${resourceType}`]
    if (alert && alert.show) {
      return _.map(alert.errors, (error, index) => (
        <div className='alert alert-danger' key={index}>{error}</div>
      ))
    }
  }

  render () {
    const {
      isFetchingDevices,
      isFetchingUsers,
      createdUser,
      updatedUser,
      users,
      devices,
    } = this.props
    const {
      selectedUser,
      selectedDevices,
      inputUserPassword,
      devicesComplete,
    } = this.state
    const currentUserSubject = updatedUser || createdUser || selectedUser || null
    return (
      <div className='step-form'>
        <div>
          <Step
            title='User'
            isCollapsed={!!currentUserSubject}
          >
            {
              currentUserSubject
              ? <div>
                { currentUserSubject.email }
              </div>
              : <div>
                <div>Username</div>
                { this.renderAlert(USER) }
                <Select
                  isSearchable
                  isClearable
                  isLoading={isFetchingUsers}
                  options={users}
                  value={selectedUser}
                  onChange={(selected) => this.handleSelect(USER, selected)}
                  onInputChange={(input) => this.handleInput(USER, input)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'email'}
                  valueKey={'user_id'}
                />
                <div>Password</div>
                { this.renderAlert(USER_PASSWORD) }
                <input
                  type='password'
                  className='input'
                  value={inputUserPassword}
                  onChange={(event) => this.handleInput(USER_PASSWORD, event.target.value)}
                />
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleCreateUser()}
                    disabled={!this.checkPrereqs(USER)}
                  >
                    Create User
                  </button>
                </div>
              </div>
            }
          </Step>
          <Step
            title='Devices'
            isCollapsed={!!devicesComplete}
          >
            {
              devicesComplete
              ? <div className='device-id-container'>
                {`${this.getDeviceStrings()}` }
              </div>
              : <div>
                <div>Device Strings</div>
                <Select
                  multi
                  isSearchable
                  isClearable
                  isLoading={isFetchingDevices}
                  options={devices}
                  value={selectedDevices}
                  onChange={(selected) => this.handleSelect(DEVICES, selected)}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  noResultsText={false}
                  labelKey={'device_string'}
                  valueKey={'id'}
                />
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleAssociateDevicesClick(currentUserSubject)}
                    disabled={!this.checkPrereqs(DEVICES)}
                  >
                    Associate Devices
                  </button>
                </div>
                <div className='button-container'>
                  <button
                    className='btn btn-primary action-button'
                    onClick={() => this.handleDissociateDevicesClick(currentUserSubject)}
                    disabled={!this.checkPrereqs(DEVICES)}
                  >
                    Dissociate Devices
                  </button>
                </div>
              </div>
            }
          </Step>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/AtHomeCreationView.jsx